import { createFileRoute } from '@tanstack/react-router';
import EmployeesOfficeTable from '@/modules/employees/EmployeesOfficeTable';

export const Route = createFileRoute('/(dashboard)/_dashboard/hr/employee/office')({
  component: EmployeesOfficeTable,
});
